import angular from 'angular';

import { appealsCounter } from './appeals.counter.directive';

import './appeals.counter.scss';

export default angular
  .module('appeals.counter', [])
  .directive('appealsCounter', appealsCounter);
